import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vad är skillnaden mellan provet för stadigvarande och tillfälligt tillstånd?";
const SHORT_ANSWER = "Provet för stadigvarande har 60 frågor och täcker fler områden. Tillfälligt prov har 44 frågor och något smalare scope.";

export const Route = createFileRoute("/fraga/vad-ar-skillnad-stadigvarande-prov-tillfalligt")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vad är skillnaden mellan provet för stadigvaran…" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Den som klarat stadigvarande prov anses kunna driva en restaurang löpande. Tillfälligt prov fokuserar på enstaka evenemang. Båda kräver godkäntgräns per område."}
      source={{ label: "FoHMFS 2014:7 – Föreskrifter om kunskapsprov", href: "https://www.folkhalsomyndigheten.se/publikationer-och-material/publikationsarkiv/f/fohmfs-20147/" }}
      extraSources={[]}
      deepGuide={{ to: "/kunskapsprov-alkohollagen", label: "Kunskapsprovet – upplägg" }}
      related={[{"to": "/fraga/galler-provet-i-alla-kommuner", "label": "Gäller godkänt kunskapsprov i alla kommuner?"}, {"to": "/fraga/hur-lange-galler-godkant-prov", "label": "Hur länge gäller ett godkänt kunskapsprov?"}, {"to": "/fraga/vilka-delar-ingar-i-provet", "label": "Vilka delar ingår i kunskapsprovet?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vad är skillnaden mellan provet för stadigvarande och til…" },
      { name: "description", content: "Provet för stadigvarande har 60 frågor och täcker fler områden. Tillfälligt prov har 44 frågor och något smalare scope." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vad-ar-skillnad-stadigvarande-prov-tillfalligt" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vad-ar-skillnad-stadigvarande-prov-tillfalligt" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vad-ar-skillnad-stadigvarande-prov-tillfalligt",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vad är skillnaden mellan provet för stadigvaran…", url: "https://alkoholprovet.se/fraga/vad-ar-skillnad-stadigvarande-prov-tillfalligt" },
      ]),
    ],
  }),
});
